import { Helmet } from "react-helmet";
import "./App.scss";
import AppRoutes from "./AppRoutes";

const noIndex = process.env.REACT_APP_NOINDEX === "true";

function App(): JSX.Element {
  return (
    <div className="App">
      {noIndex ? (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      ) : null}
      <AppRoutes />
    </div>
  );
}

export default App;
